import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@consigli/shadcn';
import { type BeamstarFailingTool } from '@consigli/types';
import { type ColumnDef } from '@tanstack/react-table';

import { DataTable } from '@/components';

import { formatCount } from '../format';

const columns: ColumnDef<BeamstarFailingTool>[] = [
  {
    header: 'Tool',
    cell: ({ row }) => (
      <div className="flex flex-col">
        <span className="font-mono text-xs font-medium">{row.original.tool}</span>
        <span className="text-xs text-muted-foreground">{row.original.agent ?? 'router'}</span>
      </div>
    ),
  },
  { header: 'Calls', cell: ({ row }) => formatCount(row.original.calls) },
  { header: 'Failed', cell: ({ row }) => formatCount(row.original.failed) },
  {
    header: 'Rate',
    cell: ({ row }) => `${((row.original.failed / row.original.calls) * 100).toFixed(1)}%`,
  },
  {
    header: 'Most common failure',
    cell: ({ row }) => (
      <span className="line-clamp-2 max-w-md whitespace-normal text-muted-foreground">
        {row.original.commonFailure}
      </span>
    ),
  },
];

interface FailingToolsCardProps {
  tools: BeamstarFailingTool[];
}

export const FailingToolsCard = ({ tools }: FailingToolsCardProps) => (
  <Card className="shadow-none">
    <CardHeader>
      <CardTitle>Failing tools</CardTitle>
      <CardDescription>
        Tools with a failed call in this range, most failures first.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <DataTable columns={columns} data={tools} isLoading={false} />
    </CardContent>
  </Card>
);
